import React, { Fragment } from 'react';
import MultiSelectBox from '@Common/MultiSelectBox/MultiSelectBox';
import InputText from '@Common/InputText';
import RadioGroup from '@Common/RadioGroup/RadioGroup';

interface AdditionalOptionsProps {
	currentTask: object;
	formFilters: object;
	onFormChange: Function;
}

//#TODO Fix field certified task
export const AdditionalOptionsComponentForm = ({ currentTask, formFilters, onFormChange }: AdditionalOptionsProps) => {
	const handleOnFormChange = (e) => {
		onFormChange([e.target.name], e.target.value);
	};

	const onDropdownChange = (value: number, name: string) => {
		onFormChange(name, value);
	};

	const handleIncludeCertificationChange = (value) => {
		const parsedValue: boolean = JSON.parse(value);
		onFormChange('includeCertificationCheckbox', parsedValue);
	};

	return (
		<Fragment>
			<div className='col-6'>
				<div className='mb-3'>
					<label htmlFor='communityId' className='title'>
						Tag(s)
					</label>
					<MultiSelectBox
						name='taskTagIds'
						idField='id'
						valueField='name'
						options={formFilters.taskTags}
						placeholder='Select all that apply'
						selectedValues={currentTask.taskTagIds ? currentTask.taskTagIds.toString() : ''}
						onChange={onDropdownChange}
						isMulti={true}
					/>
				</div>

				<div className='mb-3'>
					<label htmlFor='communityId' className='title'>
						Phase
					</label>
					<MultiSelectBox
						name='phaseId'
						idField='id'
						valueField='name'
						options={formFilters.phases}
						placeholder='What Phase is this baseline task in?'
						selectedValues={currentTask.phaseId.toString()}
						onChange={onDropdownChange}
						isMulti={false}
					/>
				</div>

				<div className='mb-3'>
					<label htmlFor='contactName' className='title'>
						Contact Name
					</label>
					<InputText
						id='contactName'
						name='contactName'
						placeholder='Who needs to be contacted to get this baseline task completed?'
						type='text'
						value={currentTask.contactName}
						onChange={handleOnFormChange}
						maxLength={175}
					/>
				</div>
			</div>
			<div className='col-6'>
				<div className='mb-3'>
					<label htmlFor='task-name' className='title'>
						Anticipated Effort&nbsp;&nbsp;<i className='fa-regular fa-info-circle fa-lg'></i>
					</label>
					<InputText
						id='anticipatedEffort'
						name='anticipatedEffort'
						placeholder='How long should this baseline task take to complete?'
						type='text'
						value={currentTask.anticipatedEffort}
						onChange={handleOnFormChange}
						maxLength={175}
					/>
				</div>
				<div className='mb-3' style={{ marginBottom: '0.8em' }}>
					<label htmlFor='task-name' className='title'>
						Require this task to be certified for completion&nbsp;&nbsp;<i className='fa-regular fa-info-circle fa-lg'></i>
					</label>
					<br />
					<div className='custom-container-radio'>
						<RadioGroup 
							defaultValue={'false'}
							value={'false'}
							options={[
								{  value: 'false', label: 'No' },
								{  value: 'true', label: 'Yes' },
							]}
							onValueChange={handleIncludeCertificationChange} />
					</div>
				</div>
				<div className='mb-3'>
					<label htmlFor='contactEmail' className='title'>
						Contact Email
					</label>
					<InputText
						id='contactEmail'
						name='contactEmail'
						placeholder=''
						type='text'
						value={currentTask.contactEmail}
						onChange={handleOnFormChange}
						maxLength={175}
					/>
				</div>
			</div>
		</Fragment>
	);
};
